
import {getToken} from '../adalConfig';

export const actionCreators = {

    // REQUEST_REGISTER_TAGS
    requestRegisterTags: (isExtended) => async (dispatch, getState) => {    
      dispatch({ type: 'REQUEST_REGISTER_TAGS' });
      const headers = { Authorization: `Bearer ${getToken()}` };
      let url = `api/Registers/registertags`;
      if(!isExtended){
        url = `api/Registers/mainregistertags`;
      }
      const response = await fetch(url, {headers});
      const registerTags = await response.json();
      dispatch({ type: 'RECEIVE_REGISTER_TAGS', registerTags });
    },
    requestRegistersTagInstance: (instanceId, tag) => async (dispatch, getState) => {       
        
      const headers = { Authorization: `Bearer ${getToken()}` };
      const url = `api/Registers/Instance/${instanceId}/${tag}`;
      const response = await fetch(url, {headers});
      if(response.ok){
          const registers = await response.json();
          dispatch({ type: 'RECEIVE_REGISTERS_INSTANCE_TAG', registers });
      } 
  },
  requestManufacturerCommsFailureRegisters: (instanceId) => async (dispatch, getState) => {       
        
    const headers = { Authorization: `Bearer ${getToken()}` };
    const url = `api/Registers/CommsFailureManufacturer/Instance/${instanceId}`;
    const response = await fetch(url, {headers});
    if(response.ok){
        const registers = await response.json();
        dispatch({ type: 'RECEIVE_MANUFACTURER_REGISTERS', registers });
    } 
  },
  requestRealtimeDatafeedRegisters: (instanceId) => async (dispatch, getState) => {       
        
    const headers = { Authorization: `Bearer ${getToken()}` };
    const url = `api/Registers/RealtimeFeeds/Instance/${instanceId}`;
    const response = await fetch(url, {headers});
    if(response.ok){
        const registers = await response.json();
        dispatch({ type: 'RECEIVE_REALTIMEFEEDS_REGISTERS', registers });
    } 
  },
};


// WEBPACK FOOTER //
// ./src/actions/registers.js